import { Box, Heading, Img, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import allTeams from "../../assets/teams/all_teams.png";
import team1 from "../../assets/teams/1.png";
import team2 from "../../assets/teams/2.png";
import team3 from "../../assets/teams/3.png";
import team4 from "../../assets/teams/4.png";
import team5 from "../../assets/teams/5.png";
import team6 from "../../assets/teams/6.png";
import team7 from "../../assets/teams/7.png";
import team8 from "../../assets/teams/8.png";
import team9 from "../../assets/teams/9.png";
import team10 from "../../assets/teams/10.png";
import team11 from "../../assets/teams/11.png";
import team12 from "../../assets/teams/12.png";
import team13 from "../../assets/teams/13.png";
import team14 from "../../assets/teams/14.png";
import team15 from "../../assets/teams/15.png";
import team16 from "../../assets/teams/16.png";
import team17 from "../../assets/teams/17.png";
import team18 from "../../assets/teams/18.png";
import team19 from "../../assets/teams/19.png";
import team20 from "../../assets/teams/20.png";
import team21 from "../../assets/teams/21.png";
import team22 from "../../assets/teams/22.png";
import team23 from "../../assets/teams/23.png";
import team24 from "../../assets/teams/24.png";
import team25 from "../../assets/teams/24.png";
import team26 from "../../assets/teams/23.png";
import { Parallax } from "react-parallax";

export const TEAMS_LIST = [
	{ image: team1, name: "Temitayo Adejoke", role: "CEO" },
	{ image: team2, name: "Jaabin Adekunle", role: "CMO" },
	{ image: team23, name: "Gabriel Owoeye", role: "CTO" },
	{ image: team25, name: "Tosin Adedeji", role: "Director of Communication & Partnerships" },
	{ image: team3, name: "Elizabeth Oyok", role: "HR" },
	{ image: team4, name: "Naomi Tariah", role: "Lawyer" },
	{ image: team5, name: "Eze NnaEmeka", role: "Marketer" },
	{ image: team6, name: "Yusuf Olatunyi", role: "Product Manager" },
	{ image: team7, name: "Ebenezer Ojo", role: "Product Manager" },
	{
		image: team8,
		name: "Samuel Balogun",
		role: "Product Designer (Team lead)",
	},
	{
		image: team9,
		name: "Frank Nussie",
		role: "Backend Developer (Team lead)",
	},
	{
		image: team10,
		name: "Liam Nussie",
		role: "Frontend Developer  (Team lead)",
	},
	// {
	//   image: team11,
	//   name: "Liam Nussie",
	//   role: "Frontend Developer  (Team lead)",
	// },
	{
		image: team11,
		name: "Gift",
		role: "Full-stack Developer",
	},
	{
		image: team24,
		name: "Mayomi Jessica",
		role: "Product Designer",
	},
	{
		image: team12,
		name: "Anita Nsikak",
		role: "Product Designer ",
	},
	{
		image: team13,
		name: "Dele-Oyero Ifeoluwa",
		role: "Frontend Developer",
	},
	{
		image: team14,
		name: "Austin Onueze",
		role: "Frontend Developer",
	},
	{
		image: team15,
		name: "Emmanuel Ochade",
		role: "Frontend Developer",
	},

	{
		image: team16,
		name: "Ejorfor Olisa",
		role: "Mobile Developer",
	},
	{
		image: team17,
		name: "Emmanuel Akogwu",
		role: "Frontend Developer",
	},
	{
		image: team18,
		name: "Clark Ifre",
		role: "Frontend Developer",
	},
	{
		image: team19,
		name: "Amakah Nwankwo",
		role: "Backend Developer",
	},
	{
		image: team20,
		name: "Adedolapo Adegoke",
		role: "Backend Developer",
	},
	{
		image: team21,
		name: "Victor",
		role: "Mobile Developer",
	},
	{
		image: team22,
		name: "Adetonye Babalola",
		role: "Backend Developer",
	},
	{
		image: team26,
		name: "Caleb Opayemi",
		role: "Project Manager",
	},
	//   {
	//     image: team23,
	//     name: "Adetoye Babalola",
	//     role: "Backend Developer",
	//   },
];

function Teams() {
	const [currentMouseLocation, setCurrentMouseLocation] = useState(null);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Box data-aos="fade-up" marginBottom="80px" padding={["0rem 2rem", "0rem 6rem"]}>
			<Parallax
				bgImage={allTeams}
				bgImageAlt="the cat"
				strength={600}
				renderLayer={() => (
					<div
						style={{
							position: "absolute",
							background: `#0000006b`,
							left: 0,
							top: 0,
							right: 0,
							width: "100%",
							height: "100%",
						}}
					/>
				)}
				bgImageStyle={{ objectFit: "cover" }}
				style={{
					height: "100vh",
					textAlign: "center",
					marginLeft: "-6rem",
					marginRight: "-6rem",
					justifyContent: "center",
					alignItems: "center",
					display: "flex",
				}}>
				<Stack color="#fff">
					<Heading fontSize={"3em"} fontFamily="Trenda-bold">
						Our Team @
					</Heading>
					<Heading
						transition="all .2s ease-in-out"
						fontSize={["4em", "10em"]}
						textTransform={"uppercase"}
						fontFamily="Trenda-heavy"
						style={{
							"-webkit-text-stroke": "1px #fff",
							"-webkit-text-fill-color": "transparent",
						}}
						_hover={{
							// "-webkit-text-stroke": "1px #fff",
							"-webkit-text-fill-color": "#fff !important",
						}}
						//       " -webkit-text-stroke"= "1px black"
						// "-webkit-text-fill-color"="white"
					>
						Zealight
					</Heading>
					Zealight
				</Stack>
			</Parallax>

			<Stack mt="90px">
				<Text mb="20px">OUR AWESOME TEAM</Text>
				<Heading fontFamily={"Trenda-bold"} mb="30px" maxW="600px">
					Learn more about the people who make us awesome
				</Heading>
				<SimpleGrid columns={[2, 3, 3, 4]} spacing="40px" mt="60px !important">
					{TEAMS_LIST.map((team, id) => {
						return (
							<Box key={id} position={"relative"} onMouseOver={() => setCurrentMouseLocation(id)} onMouseOut={() => setCurrentMouseLocation(null)}>
								<Img loading="lazy" src={team?.image} alt={team?.role} zIndex={currentMouseLocation === id ? 0 : 999} />
								<Stack
									borderRadius={"20px"}
									bg="#000000ba"
									display={currentMouseLocation === id ? "flex" : "none"}
									zIndex={currentMouseLocation === id ? 999 : 0}
									position="absolute"
									top="0"
									left="0"
									w="100%"
									h="100%"
									color="#fff"
									justifyContent="flex-end"
									alignItems="baseline"
									p="10px"
									fontSize={".8em"}>
									<Text fontWeight={"bold"}>{team.name}</Text>
									<Text maxW="120px">{team.role}</Text>
								</Stack>
							</Box>
						);
					})}
				</SimpleGrid>
			</Stack>
		</Box>
	);
}

export default Teams;
